import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setIsMenuOpen(false);
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-md z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_biz-builder-10/artifacts/6xvcab3i_DeepCoreLearningLabLogo.png?v=2" 
              alt="DeepCore Learning Lab" 
              className="h-16 w-auto object-contain"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              data-testid="nav-home-btn"
              onClick={() => scrollToSection("home")}
              className="text-gray-700 hover:text-blue-900 font-medium transition-colors"
            >
              Home
            </button>
            <button
              data-testid="nav-services-btn"
              onClick={() => scrollToSection("services")}
              className="text-gray-700 hover:text-blue-900 font-medium transition-colors"
            >
              Services
            </button>
            <button
              data-testid="nav-products-btn"
              onClick={() => scrollToSection("products")}
              className="text-gray-700 hover:text-blue-900 font-medium transition-colors"
            >
              Products
            </button>
            <button
              data-testid="nav-contact-btn"
              onClick={() => scrollToSection("contact")}
              className="text-gray-700 hover:text-blue-900 font-medium transition-colors"
            >
              Contact
            </button>
            <Button
              data-testid="nav-getstarted-btn"
              onClick={() => scrollToSection("products")}
              className="bg-gradient-to-r from-blue-900 to-blue-700 hover:from-blue-800 hover:to-blue-600 text-white px-6 rounded-full"
            >
              Get Started
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden pb-4 space-y-3">
            <button
              data-testid="mobile-nav-home-btn"
              onClick={() => scrollToSection("home")}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg"
            >
              Home
            </button>
            <button
              data-testid="mobile-nav-services-btn"
              onClick={() => scrollToSection("services")}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg"
            >
              Services
            </button>
            <button
              data-testid="mobile-nav-products-btn"
              onClick={() => scrollToSection("products")}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg"
            >
              Products
            </button>
            <button
              data-testid="mobile-nav-contact-btn"
              onClick={() => scrollToSection("contact")}
              className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-blue-50 rounded-lg"
            >
              Contact
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;